import {createWebAccount} from 'externalAPIs/hypnos';
import {authenticate} from 'externalAPIs/insurance-eligibility';
import {surveyInstance} from 'screens/InsomniaSurvey/InsomniaSurvey';
import Analytics from 'utils/Analytics';

/**
 * Handles web account creation when user submits contact information
 * @param surveyData - The survey data containing email and other user information
 */
export const handleContactInfoSubmission = async (surveyData: any) => {
  // don't create account if one already exists
  if (surveyData.person_id) {
    return;
  }
  try {
    const response = await createWebAccount(surveyData.email);
    if (response.error) {
      throw new Error(response.errorMessage);
    } else if (response.person_id) {
      console.log('Web account created');
      surveyInstance.data = {
        ...surveyInstance.data,
        person_id: response.person_id,
        hypnos_token: response.token,
      };

      // Include referral code in identify call if present
      const referralCode = surveyData.referral_code || surveyInstance.getValue('referral_code');
      const identifyPayload: {email: string; referral_code?: string} = {email: surveyData.email};
      if (referralCode) {
        identifyPayload.referral_code = referralCode;
      }
      // Update identify with referral code (createWebAccount already called identify, this ensures referral code is included)
      Analytics.identify(response.person_id, identifyPayload);

      const authenticateResponse = await authenticate(surveyData.email, response.person_id, response.token);
      if (authenticateResponse.error) {
        throw new Error(authenticateResponse.error);
      } else if (authenticateResponse.accessToken) {
        console.log('Eligibility token authenticated');
        surveyInstance.data = {
          ...surveyInstance.data,
          eligibility_token: authenticateResponse.accessToken,
        };
      }
    } else {
      throw new Error('Unknown error creating account');
    }
  } catch (error) {
    console.error('Error creating account:', error);
    throw error;
  }
};
